import {useMediaQuery, useTheme} from "@mui/material";

export default function useResponsive(query, start, end) {
    const theme = useTheme();

    const mediaUp = useMediaQuery(theme.breakpoints.up(start));
    const mediaDown = useMediaQuery(theme.breakpoints.down(start));
    const mediaBetween = useMediaQuery(theme.breakpoints.between(start, end));
    const mediaOnly = useMediaQuery(theme.breakpoints.only(start));

    return {
        up: mediaUp,
        down: mediaDown,
        between: mediaBetween,
    }[query] || mediaOnly;
}